<template>
    <div id="bigMain" style="height: 100vh; width: 100vw; display: inline-block; position: fixed; left: 0; top: 0;">
      <home-title2 :area-name="areaName"></home-title2>
      <home-header2 :area-id="areaId"></home-header2>
      <div id="main">
        <div id="left">
          <div id="homeLeftOne2" v-show="inHome">
            <home-left-one2 v-if="inHome"  @feedBack="getHomeMapFeedBack" :area-id="areaId"></home-left-one2>
          </div>
          <div id="homeLeftTwo2" v-show="inHome">
            <home-left-two2 v-if="inHome" ></home-left-two2>
          </div>
          <div id="subLeftOne2" v-show="!inHome">
            <sub-left-one2 v-if="!inHome" :area-id="areaId"></sub-left-one2>
          </div>
          <div id="subLeftTwo2" v-show="!inHome">
            <sub-left-two2 v-if="!inHome" :area-id="areaId"></sub-left-two2>
          </div>
        </div>
        <div id="center">
          <home-map2 @feedBack="getHomeMapFeedBack" :area-name="areaName" ></home-map2>
        </div>
        <div id="right">
          <div id="homeRightOne2" v-show="inHome">
            <home-right-one2 v-if="inHome" @feedBack="getHomeMapFeedBack" :area-id="areaId"></home-right-one2>
          </div>
          <div id="homeRightTwo2" v-show="inHome">
            <home-right-two2 v-if="inHome" ></home-right-two2>
          </div>
          <div id="subRightOne2" v-show="!inHome">
            <sub-right-one2 v-if="!inHome" :area-id="areaId"></sub-right-one2>
          </div>
          <div id="subRightTwo2" v-show="!inHome">
            <sub-right-two2 v-if="!inHome" :area-id="areaId"></sub-right-two2>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import HomeTitle2 from './homeComponents2/HomeTitle2'
import HomeHeader2 from './homeComponents2/HomeHeader2'
import HomeLeftOne2 from './homeComponents2/HomeLeftOne2'
import HomeMap2 from './homeComponents2/HomeMap2'
import HomeLeftTwo2 from './homeComponents2/HomeLeftTwo2'
import HomeRightOne2 from './homeComponents2/HomeRightOne2'
import HomeRightTwo2 from './homeComponents2/HomeRightTwo2'
import SubLeftOne2 from './homeComponents2/SubAreaCharts/SubLeftOne2'
import SubLeftTwo2 from './homeComponents2/SubAreaCharts/SubLeftTwo2'
import SubRightOne2 from './homeComponents2/SubAreaCharts/SubRightOne2'
import SubRightTwo2 from './homeComponents2/SubAreaCharts/SubRightTwo2'
export default {
  name: 'BigScreen2',
  components: { SubRightTwo2, SubRightOne2, SubLeftTwo2, SubLeftOne2, HomeRightTwo2, HomeRightOne2, HomeLeftTwo2, HomeMap2, HomeLeftOne2, HomeHeader2, HomeTitle2  },
  data(){
    return {
      inHome: true,
      areaName: '南京市',
      areaId:"0",
    }
  },
  methods:{
    getHomeMapFeedBack(areaName, areaId){
      this.areaId = areaId;
      this.areaName = areaName;
    },
    fadeHome(){
      new Promise(resolve =>{
        console.log('点击了');
        let arrRight = ['homeRightOne2', 'homeRightTwo2'];
        let arrLeft = ['homeLeftOne2', 'homeLeftTwo2'];
        let index = 0;
        let interval = setInterval(()=>{
          var objLeft = document.getElementById(arrLeft[index]);
          var objRight = document.getElementById(arrRight[index]);
          this.fadeElement(objLeft, -1);
          this.fadeElement(objRight, 1);
          if(index++ >= Math.min(arrRight.length, arrLeft)- 1){
            clearInterval(interval);
            resolve();
          }
        },200);
      }).then(()=>{
        this.showSub();
      })
    },
    showHome(){
      let arrRight = ['homeRightOne2', 'homeRightTwo2'].reverse();
      let arrLeft = ['homeLeftOne2', 'homeLeftTwo2'].reverse();
      let all = arrLeft.concat(arrRight);
      all.forEach(item=>{
        var obj = document.getElementById(item);
        obj.style.opacity = 0;
      })
      this.inHome = true;
      let index = 0;
      let interval = setInterval(()=>{
        var objLeft = document.getElementById(arrLeft[index]);
        var objRight = document.getElementById(arrRight[index]);
        this.showElement(objLeft, -1);
        this.showElement(objRight, 1);
        if(index++ >= Math.min(arrRight.length, arrLeft.length) - 1){
          clearInterval(interval);
        }
      },200);
    },
    showSub(){
      this.inHome = false;
      let arrRight = ['subRightOne2', 'subRightTwo2'].reverse();
      let arrLeft = ['subLeftOne2', 'subLeftTwo2'].reverse();
      let all = arrRight.concat(arrLeft);
      all.forEach(item=>{
        var obj = document.getElementById(item);
        obj.style.opacity = 0;
      })
      this.inHome = false;
      let index = 0;
      let interval = setInterval(()=>{
        console.log('index:' + index);
        console.log('leftId:' + arrLeft[index]);
        console.log('rightId:' + arrRight[index]);
        var objLeft = document.getElementById(arrLeft[index]);
        var objRight = document.getElementById(arrRight[index]);
        console.log('objLeft:' + arrLeft[index]);
        console.log('objRight:' + arrRight[index]);
        this.showElement(objLeft, -1);
        this.showElement(objRight, 1);
        if(index++ >= Math.min(arrLeft.length, arrRight.length) - 1){
          clearInterval(interval);
        }
      },100);
    },
    fadeSub(){
      new Promise(resolve => {
        let arrRight = ['subRightOne2', 'subRightTwo2'].reverse();
        let arrLeft = ['subLeftOne2', 'subLeftTwo2'].reverse();
        this.inHome = false;
        let index = 0;
        let interval = setInterval(()=>{
          var objLeft = document.getElementById(arrLeft[index]);
          var objRight = document.getElementById(arrRight[index]);
          this.fadeElement(objLeft, 1);
          this.fadeElement(objRight, -1);
          if(index++ >= Math.min(arrLeft.length, arrRight.length) - 1){
            clearInterval(interval);
            resolve();
          }
        },100);
      }).then(()=>{
        this.showHome();
      })

    },
    // 消失
    fadeElement(obj, direction){
      // direction：-1:向左，1:向右
      let interval = null;
      let opacity = 1;
      let left = 0;
      let right = 0;
      let p = new Promise(resolve => {
        interval = setInterval(()=>{
          obj.style.opacity = opacity;
          opacity = opacity - 0.05;
          // console.log(obj.style.opacity);
          left = left + direction * 2.5;
          right = left;
          obj.style.marginLeft = left + "px";
          obj.style.marginRight = "-" + right + "px";
          // console.log(obj.style.left);
          if(obj.style.opacity <= 0){
            resolve(clearInterval(interval));
          }
        }, 5);
      }).then(()=>{
        // console.log('隐藏了');
      })
    },
    // 展示元素
    showElement(obj, direction){
      // direction：-1:向左，1:向右
      obj.style.opacity = 0;
      let interval = null;
      let opacity = 0;
      let left = -50;
      let right = -50;
      if(direction === -1){
        left = 50;
        right = 50;
      }
      new Promise(resolve => {
        interval = setInterval(()=>{
          obj.style.opacity = opacity;
          opacity = opacity + 0.05;
          // console.log(obj.style.opacity);
          left = left + direction * 2.5;
          right = left;
          obj.style.marginLeft = left + "px";
          obj.style.marginRight = "-" + left + "px";
          // console.log(obj.style.left);
          if(obj.style.opacity >= 1){
            resolve(clearInterval(interval));
          }
        }, 10);
      }).then(()=>{
        console.log('隐藏了');
      })
    },
  },
  // watch:{
  //   areaName(newValue, oldValue){
  //     if(newValue === '泰州市'){
  //       this.fadeSub();
  //     }else{
  //       this.showSub();
  //     }
  //   },
  // }
}
</script>

<style scoped>
  #bigMain{
    background: radial-gradient(circle, #0f266a, #0e112d);
    background: -ms-radial-gradient(circle, #0f266a, #0e112d);
    background: -webkit-linear-gradient(circle, #0f266a, #0e112d);
    background: -moz-linear-gradient(circle, #0f266a, #0e112d);
  }
 #main{
   display: flex;
   display: -moz-flex;
   display: -webkit-flex;
   height: 100%;
   overflow: hidden;
 }
  #left, #right{
    /*background-color: green;*/
    display: flex;
    flex-direction: column;
    width: 400px;
  }
  /*#left > div, #right > div{*/
    /*flex: 1;*/
  /*}*/
  #center{
    /*background-color: #20a0ff;*/
    flex: 1;
  }
</style>
